module.exports = __webpack_public_path__ + "static/img/right.6c5be3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/us/right.jpg
// module id = E2TR
// module chunks = 1